import { useState, useEffect, useMemo, useCallback } from "react";
import { APILA } from "../../../../../../config/apila";
import { APIMS } from "../../../../../../config/apims";
import Modal from "react-bootstrap/Modal";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

export default function ModalElementUpdate(props) {
  const token = localStorage.getItem("token");
  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loadingCabang, setLoadingCabang] = useState(false);
  const [loadingSekolah, setLoadingSekolah] = useState(false);
  const [getDataCabang, setGetDataCabang] = useState([]);
  const [getSekolah, setGetSekolah] = useState([]);
  const [getDimensi, setGetDimensi] = useState([]);
  const [selectedSemesters, setSelectedSemesters] = useState([]);

  const safeValue = (value) => value ?? "";

  const [form, setForm] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    name_element: "",
    ysb_dimensi_id: "",
    description: "",
    output_id_user: "",
    user_id: "",
  });

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const getResponseCabang = useCallback(async () => {
    setLoadingCabang(true);

    try {
      const response = await APIMS.get(
        "/api/branches?page=1&limit=1000&ascending=1&search=",
        fetchParams
      );

      if (response?.status === 200) {
        setGetDataCabang(response?.data?.data || []);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data cabang",
      });
    } finally {
      setLoadingCabang(false);
    }
  }, [fetchParams]);

  const getResponseSekolah = useCallback(async () => {
    if (!form.ysb_branch_id) {
      setGetSekolah([]);
      return;
    }

    setLoadingSekolah(true);

    try {
      const response = await APIMS.get(
        `/api/schools?page=1&limit=1000&ascending=1&search=&branch=${form.ysb_branch_id}`,
        fetchParams
      );

      if (response?.status === 200) {
        setGetSekolah(response?.data?.data || []);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data sekolah",
      });
    } finally {
      setLoadingSekolah(false);
    }
  }, [fetchParams, form.ysb_branch_id]);

  const getResponseDimensi = useCallback(async () => {
    try {
      const response = await APILA.get(
        "/api/access/dimensis?page=0&limit=100&ascending=1&search=",
        fetchParams
      );
      setGetDimensi(response?.data?.data || []);
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data dimensi",
      });
    }
  }, [fetchParams]);

  useEffect(() => {
    if (!props.show) return;

    getResponseCabang();
    getResponseDimensi();
  }, [props.show, getResponseCabang, getResponseDimensi]);

  useEffect(() => {
    if (!props.show) return;

    const rawSemesterIds = props?.dataUpdate?.ysb_semester_id ?? props?.selectedSemesterId;
    const currentSemesterIds = (Array.isArray(rawSemesterIds) ? rawSemesterIds : [rawSemesterIds])
      .filter((value) => value !== null && value !== undefined && value !== "")
      .map(String);

    setSelectedSemesters(currentSemesterIds);

    setForm((prev) => ({
      ...prev,
      ysb_semester_id: currentSemesterIds,
      ysb_branch_id: safeValue(props?.dataUpdate?.ysb_branch_id),
      ysb_school_id: safeValue(props?.dataUpdate?.ysb_school_id),
      name_element: safeValue(props?.dataUpdate?.name_element),
      ysb_dimensi_id: safeValue(props?.dataUpdate?.ysb_dimensi_id),
      description: safeValue(props?.dataUpdate?.description),
      output_id_user: safeValue(props?.dataUpdate?.output_id_user),
      user_id: safeValue(props?.dataUpdate?.user_id),
    }));
  }, [props.show, props.dataUpdate]);

  useEffect(() => {
    if (!props.show) return;
    getResponseSekolah();
  }, [props.show, getResponseSekolah]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,
      ...(name === "ysb_branch_id" ? { ysb_school_id: "" } : {}),
    }));
  };

  const handleSemesterChange = (semesterId) => {
    const id = String(semesterId);
    setSelectedSemesters((previous) =>
      previous.includes(id)
        ? previous.filter((item) => item !== id)
        : [...previous, id]
    );
  };

  const getSchoolLevel = (schoolName = "") => {
    const name = schoolName.toUpperCase();
    if (name.startsWith("SD")) return 1;
    if (name.startsWith("SMP")) return 2;
    if (name.startsWith("SMA")) return 3;
    return 99;
  };

  const sortedSchools = useMemo(() => {
    return [...getSekolah]
      .filter((school) => school?.school_code !== "BASEMENT_BEKASI")
      .sort((a, b) => {
        const levelDiff =
          getSchoolLevel(a?.school_name) - getSchoolLevel(b?.school_name);

        if (levelDiff !== 0) return levelDiff;

        return String(a?.school_name || "").localeCompare(
          String(b?.school_name || ""),
          "id"
        );
      });
  }, [getSekolah]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      if (selectedSemesters.length === 0) {
        ToastError.fire({
          icon: "warning",
          title: "Pilih semester",
        });
        return;
      }

      const semesters = (props.semesterOptions || []).filter(
        (item) => selectedSemesters.includes(String(item?.id))
      );
      const academicYearIds = [...new Set(semesters.map((item) => item?.ysb_academic_year_id).filter(Boolean))];
      if (semesters.length !== selectedSemesters.length || academicYearIds.length !== 1) {
        throw new Error("ID tahun ajaran tidak tersedia pada semester yang dipilih");
      }

      const response = await APILA.put(
        `/api/elements/v2/${props.id}`,
        {
          ysb_academic_year_id: academicYearIds[0],
          ysb_semester_id: selectedSemesters,
          ysb_branch_id: form.ysb_branch_id,
          ysb_school_id: form.ysb_school_id,
          name_element: form.name_element,
          ysb_dimensi_id: form.ysb_dimensi_id,
          description: form.description,
          user_id: idUser,
        },
        fetchParams
      );

      if (response?.status === 200 || response?.status === 201) {
        ToastSuccess.fire({
          icon: "success",
          title: response?.data?.message || "Data berhasil diperbarui",
        });

        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || error.message || "Gagal memperbarui data",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-update-element"
    >
      <form onSubmit={handleSubmit}>
        <Modal.Header className="sims-modal-header">
          <div>
            <h5 id="modal-update-element" className="sims-modal-title">
              Update Element
            </h5>
          </div>

          <button
            type="button"
            className="sims-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </Modal.Header>

        <Modal.Body className="sims-modal-body mt-1 mx-2">
          <div className="sims-form-grid">
            <div className="sims-form-group">
              <label className="sims-form-label" htmlFor="update-branch">
                Cabang <span>*</span>
              </label>

              <select
                id="update-branch"
                name="ysb_branch_id"
                className="sims-form-select"
                value={form.ysb_branch_id}
                onChange={handleChange}
                disabled={loadingCabang}
                required
              >
                <option value="">
                  {loadingCabang ? "Memuat cabang..." : "Pilih Cabang"}
                </option>

                {getDataCabang.map((cabang) => (
                  <option
                    key={cabang?.id || cabang?.branch_code}
                    value={cabang?.branch_code}
                  >
                    {cabang?.branch_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="sims-form-group">
              <label className="sims-form-label" htmlFor="update-school">
                Sekolah <span>*</span>
              </label>

              <select
                id="update-school"
                name="ysb_school_id"
                className="sims-form-select"
                value={form.ysb_school_id}
                onChange={handleChange}
                disabled={!form.ysb_branch_id || loadingSekolah}
                required
              >
                <option value="">
                  {!form.ysb_branch_id
                    ? "Pilih Cabang terlebih dahulu"
                    : loadingSekolah
                    ? "Memuat sekolah..."
                    : "Pilih Sekolah"}
                </option>

                {sortedSchools.map((school) => (
                  <option
                    key={school?.id || school?.school_code}
                    value={school?.school_code}
                  >
                    {school?.school_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="sims-form-group sims-form-span-2">
              <label className="sims-form-label">
                Pilih Semester <span>*</span>
              </label>

              <div
                className="bobot-semester-options"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: "12px",
                }}
              >
                {(props.semesterOptions || []).map((semester) => {
                  const semesterId = String(semester?.id);
                  const isChecked = selectedSemesters.includes(semesterId);

                  return (
                    <label
                      className="bobot-semester-option"
                      key={semesterId}
                      style={{
                        minHeight: "50px",
                        padding: "0 14px",
                        border: "1px solid #d8e0f0",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        cursor: "pointer",
                        background: "#fff",
                        fontWeight: 600,
                        margin: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => handleSemesterChange(semesterId)}
                        style={{
                          width: "18px",
                          height: "18px",
                          cursor: "pointer",
                        }}
                      />
                      <span style={{ fontSize: "13px" }}>
                        Semester {semester?.semester}
                      </span>
                    </label>
                  );
                })}
              </div>
            </div>

            <div className="sims-form-group sims-form-span-2">
              <label className="sims-form-label">
                Dimensi <span>*</span>
              </label>

              <select
                className="sims-form-select"
                name="ysb_dimensi_id"
                value={form.ysb_dimensi_id}
                onChange={handleChange}
                required
              >
                <option value="">Pilih Dimensi..</option>
                {getDimensi.map((dimensi) => (
                  <option key={dimensi?.id} value={dimensi?.id}>
                    {dimensi?.name_dimensi}
                  </option>
                ))}
              </select>
            </div>

            <div className="sims-form-group sims-form-span-2">
              <label className="sims-form-label">
                Nomor Element <span>*</span>
              </label>
              <input
                className="sims-form-input"
                required
                autoComplete="off"
                type="text"
                name="name_element"
                onChange={handleChange}
                value={form.name_element}
              />
            </div>

            <div className="sims-form-group sims-form-span-2">
              <label className="sims-form-label">
                Nama Element <span>*</span>
              </label>
              <input
                className="sims-form-input"
                required
                autoComplete="off"
                type="text"
                name="description"
                onChange={handleChange}
                value={form.description}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                <span>Menyimpan...</span>
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFloppyDisk} />
                <span>Perbarui</span>
              </>
            )}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
